import React from "react";
import { Menu, Home, Award, BarChart2, Users, ClipboardList, LogOut } from "lucide-react";
import { LOGO_DATA_URL } from "../data/mockData";
const NAV = [
  { key: "dashboard", label: "मुख्यपृष्ठ", icon: Home },
  { key: "applications", label: "अर्ज व्यवस्थापन", icon: ClipboardList },
  { key: "award", label: "पुरस्कार निवड", icon: Award },
  // { key: "reports", label: "अहवाल व निर्यात", icon: BarChart2 },
  { key: "users", label: "वापरकर्ता व्यवस्थापन", icon: Users },
];
export function Sidebar({ page, setPage, role, onLogout, mobileOpen, onClose }) {
  return (
    <>
      {mobileOpen && (
        <div
          className="fixed inset-0 bg-slate-900/55 z-40 md:hidden"
          onClick={onClose}
        />
      )}
      <aside
        className={`bg-slate-950 text-slate-200 p-4 flex flex-col h-screen fixed md:sticky top-0 left-0 z-50 w-60 shrink-0 transition-transform duration-300 ${mobileOpen ? "translate-x-0" : "-translate-x-full md:translate-x-0"}`}
      >
        <div className="flex items-center gap-2.5 pb-4 mb-3 border-b border-white/10">
          <div className="w-9 h-9 rounded-full border border-amber-400 overflow-hidden shrink-0">
            <img
              src={LOGO_DATA_URL}
              alt="सातारा जिल्हा परिषद लोगो"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="text-xs font-semibold leading-snug">
            सातारा जि. प.
            <span className="block text-[10px] font-normal opacity-60">
              शिक्षक पुरस्कार पोर्टल
            </span>
          </div>
        </div>
        {NAV.map((n) => (
          <div
            key={n.key}
            onClick={() => {
              setPage(n.key);
              onClose();
            }}
            className={`flex items-center gap-2.5 px-3 py-2.5 rounded-lg cursor-pointer text-sm mb-0.5 font-medium ${page === n.key ? "bg-amber-400 text-slate-950 font-bold" : "text-slate-300 hover:bg-white/5 hover:text-white"}`}
          >
            <n.icon size={16} /> {n.label}
          </div>
        ))}
        <div className="mt-auto pt-3 border-t border-white/10">
          <div className="flex items-center gap-2 bg-white/5 rounded-lg p-2 mb-2.5">
            <div className="w-8 h-8 rounded-full bg-amber-400 text-slate-950 flex items-center justify-center font-bold text-xs">
              {role.slice(0, 1)}
            </div>
            <div>
              <b className="block text-xs text-white">{role}</b>
              <small className="text-[10px] text-slate-400">सत्र सक्रिय</small>
            </div>
          </div>
          <button
            onClick={onLogout}
            className="text-xs text-slate-400 underline flex items-center gap-1"
          >
            <LogOut size={12} /> बाहेर पडा
          </button>
        </div>
      </aside>
    </>
  );
}
const TITLES = {
  dashboard: "मुख्यपृष्ठ — डॅशबोर्ड",
  applications: "अर्ज व्यवस्थापन",
  award: "पुरस्कार निवड व श्रेणीक्रम",
  // reports: "अहवाल व निर्यात",
  users: "वापरकर्ता व्यवस्थापन",
  detail: "अर्ज तपशील",
};
export function Topbar({ page, onMenuClick }) {
  return (
    <div
      className="relative text-white px-4 sm:px-7 py-3.5 flex justify-between items-center gap-3"
      style={{ background: "linear-gradient(135deg,#0e2a47,#1f4d78)" }}
    >
      <div className="flex items-center gap-3 min-w-0">
        <button
          onClick={onMenuClick}
          className="md:hidden w-9 h-9 rounded-lg bg-white/10 flex items-center justify-center shrink-0"
          aria-label="मेनू"
        >
          <Menu size={18} />
        </button>
        <h2 className="text-base truncate" style={{ fontFamily: "serif" }}>
          {TITLES[page]}
        </h2>
      </div>
      <div
        className="absolute left-0 right-0 bottom-0 h-[3px]"
        style={{ background: "linear-gradient(90deg,#dc9a34,#f0c268,#dc9a34)" }}
      />
    </div>
  );
}
